import { Component, OnInit, ViewChild } from '@angular/core';
import { DataManager, WebApiAdaptor, Query} from '@syncfusion/ej2-data';
import { PageEventArgs, GridComponent, PageSettingsModel, SelectionSettingsModel, ToolbarItems } from '@syncfusion/ej2-angular-grids';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';

import { SharedFunctions } from '../../../../../src/app/shared/shared.functions';

import { MonedaService, MovimientoService, MenuFuncionService, TenantService, ConsorcioService, ComunidadService, UnidadFuncionalService } from '../../../../../src/app/shared/services';
import { GridPageSettings, MenuFuncionCodes, Moneda, SearchMonedaRequest, TenantFeatureFlags, LocalStorageKeys, Consorcio, Comunidad, EstadoConstants, SearchMovimientoRequest, DialogDetalleMovimientosCuentasDeudorasRequestDto, EnviarDetalleDeudaRequestDto,
  SearchReporteCuentasDeudorasRequest, SearchUnidadFuncionalRequest, UnidadFuncional, SearchConsorcioRequest, SearchComunidadRequest
 } from '../../../../../src/app/shared/model';

import { DialogDetalleMovimientosCuentasDeudorasComponent } from './components/dialogDetalleMovimientosCuentasDeudoras.component';
import { ExportMediaTypeConstants } from '../../../shared/model';

@Component({
  selector: 'app-reporte-cuentas-deudoras',
  templateUrl: './reporte-cuentas-deudoras.component.html',
  styleUrls: ['./reporte-cuentas-deudoras.component.scss']
})

export class ReporteCuentasDeudorasComponent implements OnInit {
  @ViewChild('grid')
  public grid: GridComponent;

  public data: DataManager;
  public format = { type:'date', format:'dd/MM/yyyy HH:mm' }
  total: number = 0;
  searchForm: FormGroup;

  isValidating: boolean = false;
  isSearching: boolean = false;
  isExporting: boolean = false;

  isMonedaSearching: boolean = false;
  isStatisticsSearching: boolean = false;
  isUnidadesFuncionalesSearching: boolean = false;
  isConsorcioSearching: boolean = false;
  isComunidadSearching: boolean = false;
  isProveedorAutoSearching: boolean = false;

  canViewComunidad: boolean = false;
  canViewConsorcio: boolean = false;
  canViewPersona: boolean = false;
  canViewUf: boolean = false;

  canAdd: boolean = false;
  canView: boolean = false;
  canViewDetail: boolean = false;
  verSoloActivos: boolean = true;

  monedaList: Moneda[];
  consorcioList: Consorcio[];
  comunidadList: Comunidad[];
  ufList: UnidadFuncional[];

  tenantFeatureFlags: TenantFeatureFlags;

  public query: Query;

  public totales: any[];
  public totalesVencidos: any[];

  public selectionOptions: SelectionSettingsModel;
  public pageSizes: number[];
  public toolbarOptions: ToolbarItems[];
  public pageSettings: PageSettingsModel;

  constructor(
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    private sharedFunctions: SharedFunctions,
    private router: Router,
    private menuService: MenuFuncionService,
    private service: MovimientoService,
    private monedaService: MonedaService,
    private tenantService: TenantService,
    private consorcioService: ConsorcioService,
    private comunidadService: ComunidadService,
    private unidadFuncionalService: UnidadFuncionalService,
    private datePipe: DatePipe) {

  }

  ngOnInit(): void {
    this.isValidating = true;
    this.menuService.checkMenu(MenuFuncionCodes.REPORTE_CUENTAS_DEUDORAS).subscribe(data => {
      this.isValidating = false;
      if (data != null && data.Success && data.Result) {
        this.tenantService.getTenantFeatureFlagsById(this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.TenantId)).subscribe(dataTenant => {
          this.isValidating = false;
          if (dataTenant != null && dataTenant.Success) {
            this.tenantFeatureFlags = dataTenant.Result;
            this.loadView();
          }
          else {
            this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
            // this.onCancel();
          }
        },
        (err: HttpErrorResponse) => {
          this.isValidating = false;
          this.sharedFunctions.handleError(err, true);
        })
      }
      else {
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.router.navigate(['/']);
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err, true);
    });
  }

  loadView() {
    this.canView = true;

    this.buildForm();

    this.getMonedas();
    this.getConsorcios();
    this.getComunidades();

    this.pageSizes = GridPageSettings.PageSizeList;
    this.pageSettings = { pageCount: GridPageSettings.PageCount, pageSize: this.pageSizes[1], pageSizes: this.pageSizes };

    this.setPermissions();

    var filtros = this.sharedFunctions.getReporteFiltros("app-reporteCuentasDeudoras");

    if (filtros != null) {
      this.searchForm.patchValue(filtros);
      if (filtros.gridPage != null && filtros.gridPage > 0)
        this.pageSettings.currentPage = filtros.gridPage;

      if (!(this.searchForm.get('VerAgrupadoPorUnidadFuncional')?.value == true))
        this.searchForm.get('VerDetalleContactos')?.setValue(null);

      if (this.searchForm.get('ComunidadId')?.value != null)
        this.onDeudaFiltroUfComunidadSelect();
    }

    this.setQueryParams();
    this.data = new DataManager({
      url: this.service.searchReporteCuentasDeudorasUrl(),
      adaptor: new WebApiAdaptor(),
      headers: [this.service.getAuthorizationHeader(),this.service.getTenantHeader()]
    });

    this.getSearchEstadisticas();
  }

  setPermissions() {
    this.menuService.checkMenu(MenuFuncionCodes.COMUNIDAD_LIST).subscribe(data => {
      if (data != null && data.Success)
        this.canViewComunidad = (data?.Result ?? false);
    },
    (err: HttpErrorResponse) => {
      this.sharedFunctions.handleError(err);
    });

    this.menuService.checkMenu(MenuFuncionCodes.CONSORCIO_LIST).subscribe(data => {
      if (data != null && data.Success)
        this.canViewConsorcio = (data?.Result ?? false);
    },
    (err: HttpErrorResponse) => {
      this.sharedFunctions.handleError(err);
    });

    this.menuService.checkMenuPadre(MenuFuncionCodes.PERSONA).subscribe(data => {
      if (data != null && data.Success)
        this.canViewPersona = (data?.Result != null && data?.Result?.length > 0);
    },
    (err: HttpErrorResponse) => {
      this.sharedFunctions.handleError(err);
    });

    this.menuService.checkMenuPadre(MenuFuncionCodes.UNIDAD_FUNCIONAL).subscribe(data => {
      if (data != null && data.Success)
        this.canViewUf = (data?.Result != null && data?.Result?.length > 0);
    },
    (err: HttpErrorResponse) => {
      this.sharedFunctions.handleError(err);
    });
  }

  buildForm() {
    var fechaHoy = new Date();

    var cId = this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.ConsorcioId);
    if (cId != null && cId.length > 0 && cId > 0)
      cId = Number(cId);

    this.searchForm = this.formBuilder.group({
      'FechaMovimientoDesde': [null],
      'FechaMovimientoHasta': [fechaHoy],
      'MonedaId': [null],

      'NroDocumento': [null],
      'MailContacto': [null],
      'MovilContacto': [null],
      'Usuario': [null],
      'ComunidadId': [null],
      'ConsorcioId': [cId],
      'UnidadFuncionalId': [null],
      // 'Proveedor': [null],

      'FechaVencimientoControl': [fechaHoy],
      'VerAgrupadoPorUnidadFuncional': [true],
      'VerDetalleContactos': [false],

      'gridPage': [1]
    });

    // var filtros = this.sharedFunctions.getReporteFiltros("app-reporteCuentasDeudoras");
    // if (filtros != null)
    //   this.searchForm.patchValue(filtros);
  }

  isProcessing() {
    return (this.isSearching || this.isExporting);
  }

  clearDate(formFieldName: string) {
    if (formFieldName != null && formFieldName.length > 0) {
      if (this.searchForm.get(formFieldName) != null && this.searchForm.get(formFieldName)?.value)
        this.searchForm.get(formFieldName)?.setValue(null);
    }
  }

  getConsorcios() {
    if (!this.tenantFeatureFlags?.HabilitarGestionConsorcio)
      return;

    var r = new SearchConsorcioRequest(null, null, true, "Nombre", null, null, null, null, null, true);
    this.isConsorcioSearching = true;

    this.consorcioService.search(r).subscribe(data => {
      this.isConsorcioSearching = false;
      this.consorcioList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isConsorcioSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getComunidades() {
    var r = new SearchComunidadRequest(null, null, true, "Nombre", null, null, null, null, null, true);
    this.isComunidadSearching = true;

    this.comunidadService.search(r).subscribe(data => {
      this.isComunidadSearching = false;
      this.comunidadList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isComunidadSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getMonedas() {
    this.isMonedaSearching = true;
    let searchAllMonedas = new SearchMonedaRequest(null, null, true, "Codigo", null, null, null, true);
    this.monedaService.search(searchAllMonedas).subscribe(data => {
      this.isMonedaSearching = false;
      if (data != null)
        this.monedaList = data.result;
    },
    (err: HttpErrorResponse) => {
      this.isMonedaSearching = false;
      this.sharedFunctions.handleError(err);
    })
  }

  onSearch() {
    if (!(this.searchForm.get('VerAgrupadoPorUnidadFuncional')?.value == true))
      this.searchForm.get('VerDetalleContactos')?.setValue(null);

    this.isSearching = true;

    this.searchForm.get('gridPage')?.setValue(1);
    this.sharedFunctions.setReporteFiltros("app-reporteCuentasDeudoras", this.searchForm.getRawValue());

    this.setQueryParams();

    this.getSearchEstadisticas();
    this.grid.refresh();

    this.isSearching = false;
  }

  getSearchEstadisticas() {
    var search = new SearchReporteCuentasDeudorasRequest(null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null);
    search = {
      ...search,
      ...this.searchForm.value
    };

    this.isStatisticsSearching = true;
    this.service.getReporteCuentasDeudorasEstadisticas(search).subscribe(data => {
      this.isStatisticsSearching = false;
      if (data.Success) {
        this.totales = data.Result.TotalSaldos;
        this.totalesVencidos = data.Result.TotalSaldosVencidos;
      }
    },
    (err: HttpErrorResponse) => {
      this.isStatisticsSearching = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  setQueryParams() {
    if (this.query == null)
      this.query = new Query();

    var index = this.query.params.findIndex(obj => obj.key === "FechaMovimientoDesde");
    if (index >= 0)
      this.query.params[index].value = this.datePipe.transform(this.searchForm.value.FechaMovimientoDesde, "yyyy-MM-dd");
    else
      this.query.addParams("FechaMovimientoDesde", this.datePipe.transform(this.searchForm.value.FechaMovimientoDesde, "yyyy-MM-dd"));

    index = this.query.params.findIndex(obj => obj.key === "FechaMovimientoHasta");
    if (index >= 0)
      this.query.params[index].value = this.datePipe.transform(this.searchForm.value.FechaMovimientoHasta, "yyyy-MM-dd");
    else
      this.query.addParams("FechaMovimientoHasta", this.datePipe.transform(this.searchForm.value.FechaMovimientoHasta, "yyyy-MM-dd"));

    index = this.query.params.findIndex(obj => obj.key === "MonedaId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.MonedaId;
    else
      this.query.addParams("MonedaId",this.searchForm.value.MonedaId);

    index = this.query.params.findIndex(obj => obj.key === "ConsorcioId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.ConsorcioId;
    else
      this.query.addParams("ConsorcioId",this.searchForm.value.ConsorcioId);

    index = this.query.params.findIndex(obj => obj.key === "ComunidadId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.ComunidadId;
    else
      this.query.addParams("ComunidadId",this.searchForm.value.ComunidadId);

    index = this.query.params.findIndex(obj => obj.key === "UnidadFuncionalId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.UnidadFuncionalId;
    else
      this.query.addParams("UnidadFuncionalId",this.searchForm.value.UnidadFuncionalId);

    index = this.query.params.findIndex(obj => obj.key === "Usuario");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.Usuario;
    else
      this.query.addParams("Usuario",this.searchForm.value.Usuario);

    index = this.query.params.findIndex(obj => obj.key === "NroDocumento");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.NroDocumento;
    else
      this.query.addParams("NroDocumento",this.searchForm.value.NroDocumento);

    index = this.query.params.findIndex(obj => obj.key === "MailContacto");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.MailContacto;
    else
      this.query.addParams("MailContacto",this.searchForm.value.MailContacto);

    index = this.query.params.findIndex(obj => obj.key === "MovilContacto");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.MovilContacto;
    else
      this.query.addParams("MovilContacto",this.searchForm.value.MovilContacto);

    index = this.query.params.findIndex(obj => obj.key === "FechaVencimientoControl");
    if (index >= 0)
      this.query.params[index].value = this.datePipe.transform(this.searchForm.value.FechaVencimientoControl, "yyyy-MM-dd");
    else
      this.query.addParams("FechaVencimientoControl", this.datePipe.transform(this.searchForm.value.FechaVencimientoControl, "yyyy-MM-dd"));

    index = this.query.params.findIndex(obj => obj.key === "VerAgrupadoPorUnidadFuncional");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.VerAgrupadoPorUnidadFuncional;
    else
      this.query.addParams("VerAgrupadoPorUnidadFuncional", this.searchForm.value.VerAgrupadoPorUnidadFuncional);

    index = this.query.params.findIndex(obj => obj.key === "VerDetalleContactos");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.VerDetalleContactos;
    else
      this.query.addParams("VerDetalleContactos", this.searchForm.value.VerDetalleContactos);
  }

//#region grid

  onActionBegin(args: PageEventArgs) {
    if (args.requestType === 'paging' && !this.isSearching)
    {
      this.searchForm.get('gridPage')?.setValue(args.currentPage);
      this.sharedFunctions.setReporteFiltros("app-reporteCuentasDeudoras", this.searchForm.getRawValue());
    }
  }

//#endregion

  onDeudaFiltroUfComunidadSelect() {
    if (!this.tenantFeatureFlags?.HabilitarGestionUf)
      return;

    this.searchForm?.get("UnidadFuncionalId")?.setValue(null);

    var cId = this.searchForm?.get("ComunidadId")?.value;
    if (cId == null || cId <= 0) {
      this.ufList = [];
      return false;
    }

    var r = new SearchUnidadFuncionalRequest(null, null, true, "Codigo", null, null, null, null, null, null, cId, null, true);
    this.isUnidadesFuncionalesSearching = true;

    this.unidadFuncionalService.search(r).subscribe(data => {
      this.isUnidadesFuncionalesSearching = false;
      this.ufList = data.result;
    },
    (err: HttpErrorResponse) => {
      this.isUnidadesFuncionalesSearching = false;
      this.sharedFunctions.handleError(err);
    })
  }

  onExport() {
    if (!(this.searchForm.get('VerAgrupadoPorUnidadFuncional')?.value == true))
      this.searchForm.get('VerDetalleContactos')?.setValue(null);

    var search = new SearchReporteCuentasDeudorasRequest(null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null);
    search = {
      ...search,
      ...this.searchForm.value
    };

    this.isExporting = true;
    this.service.exportReporteCuentasDeudoras(search).subscribe((data: Blob) => {
      this.isExporting = false;
      var fileUrl = URL.createObjectURL(data);

      var anchor = document.createElement("a");
      anchor.download = "CuentasDeudoras_" + this.datePipe.transform(new Date(),"yyyy-MM-dd") + this.sharedFunctions.getFileExtension(ExportMediaTypeConstants.Csv);
      anchor.href = fileUrl;
      anchor.click();
    },
    (err: HttpErrorResponse) => {
      this.isExporting = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  openDialogDetalleMovimientos(item: any, verSoloContactos: boolean) {

    var search = new SearchMovimientoRequest(null, null, true, "FechaMovimiento", null, null, null, null, null, null, null, null, null, null, null, null,
      null, null, null, null, null, null, null, null, null, null, null, null, null, null, true, true, null, null);

    search = {
      ...search,
      ...this.searchForm.value,
      ... {
        // FechaVencimientoHasta: this.searchForm.get("FechaVencimientoControl").value,
        CuentaImputadaId: item?.CuentaImputadaId,
        Signo: -1,
        Estados: EstadoConstants.ESTADO_MOVIMIENTO_CONFIRMADO.toString(),
        VerSoloDeudasPendientes: true,
        VerSoloActivos: true
      }
    }

    const dialogRef = this.dialog.open(DialogDetalleMovimientosCuentasDeudorasComponent, {
      data: new DialogDetalleMovimientosCuentasDeudorasRequestDto(search, this.searchForm.get("FechaVencimientoControl")?.value, verSoloContactos, item)
    });

    dialogRef.afterClosed().subscribe((result: any) => {
    });
  }

  enviarDetalleDeuda(item: any, medio: string) {
    var search = new SearchMovimientoRequest(null, null, true, "FechaMovimiento", null, null, null, null, null, null, null, null, null, null, null, null,
      null, null, null, null, null, null, null, null, null, null, null, null, null, null, true, true, null, null);

    search = {
      ...search,
      ...this.searchForm.value,
      ... {
        FechaMovimientoDesde: (this.searchForm.value.FechaMovimientoDesde != null ? this.datePipe.transform(this.searchForm.value.FechaMovimientoDesde, "yyyy-MM-dd") : null),
        FechaMovimientoHasta: (this.searchForm.value.FechaMovimientoHasta != null ? this.datePipe.transform(this.searchForm.value.FechaMovimientoHasta, "yyyy-MM-dd") : null),
        FechaVencimientoHasta: (this.searchForm.value.FechaVencimientoControl != null ? this.datePipe.transform(this.searchForm.value.FechaVencimientoControl, "yyyy-MM-dd") : null),
        CuentaImputadaId: item?.CuentaImputadaId,
        Signo: -1,
        Estados: EstadoConstants.ESTADO_MOVIMIENTO_CONFIRMADO.toString(),
        VerSoloDeudasPendientes: true,
        VerSoloActivos: true
      }
    }
    var r = new EnviarDetalleDeudaRequestDto(medio, null, search);

    // this.isContactosSearching = true;
    this.service.enviarDetalleDeuda(r).subscribe(data => {
      // this.isContactosSearching = false;
      if (data != null && data.Success) {
        switch (medio) {
          case "PDF":
            this.sharedFunctions.showMessage("Próximamente!", "Operación Exitosa!");
            break;

          case "MAIL":
            this.sharedFunctions.showMessage("Deuda enviada éxitosamente!", "Operación Exitosa!");
            break;
        }
      }
    },
    (err: HttpErrorResponse) => {
      // this.isContactosSearching = false;
      this.sharedFunctions.handleError(err, true);
    })
  }
}
